// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/1065

import type { DashSurface } from "./dash_surface";

const DashSurfaceValues: DashSurface[] = [
    "web",
    "desktop",
    "extension",
    "start_page",
    "web_no_ext",
    "mobile_webapp",
    "hornet",
    "webapp",
    "pollux",
    "native_ios",
    "native_android",
    "esv",
    "native_dbapp_ios",
    "native_dbapp_android",
];

export function getDashSurfaceFromString(s: string): DashSurface | undefined {
    return DashSurfaceValues.find(e => e === s?.toLowerCase());
}
